import { ref } from 'vue';
import { useGetUser } from '@ilteducation/customer-mgmt';
import { GetUserResponse } from '@ilteducation/customer-mgmt-types';

const user = ref<GetUserResponse | null>(null);
const isLoading = ref<boolean>(false);
export const useSidebarUser = () => {
  const { loadUser } = useGetUser();

  const getUser = async (uid: string, reFetch: boolean = false) => {
    isLoading.value = true;
    if (!user.value || (user.value && user.value.uid !== uid)) {
      user.value = null;
      const updatedUser = await loadUser(uid);
      user.value = updatedUser;
    } else if (reFetch) {
      const updatedUser = await loadUser(uid);
      user.value = updatedUser;
    }
    isLoading.value = false;
  };

  return {
    user,
    isLoading,
    getUser,
  };
};
